import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

interface IMilestone {
  yearKey: string;
  descKey: string;
}

@Component({
  selector: 'app-our-journey',
  templateUrl: './our-journey.component.html',
  styleUrl: './our-journey.component.scss',
  standalone: false,
})
export class OurJourneyComponent {
  carouselOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    nav: false,
    margin: 24,
    responsive: {
      0: { items: 1 },
      769: { items: 2 },
      992: { items: 3 },
      1200: { items: 4 },
    },
  };

  readonly milestones: IMilestone[] = [
    { yearKey: 'our_journey.milestone_1_year', descKey: 'our_journey.milestone_1_desc' },
    { yearKey: 'our_journey.milestone_2_year', descKey: 'our_journey.milestone_2_desc' },
    { yearKey: 'our_journey.milestone_3_year', descKey: 'our_journey.milestone_3_desc' },
    { yearKey: 'our_journey.milestone_4_year', descKey: 'our_journey.milestone_4_desc' },
    { yearKey: 'our_journey.milestone_5_year', descKey: 'our_journey.milestone_5_desc' },
  ];
}
